
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"25","cy":"25","r":"25","fill":"#98C1DD"}}),_c('path',{attrs:{"d":"M26.021 34.745h0l-.872.872-10.475-10.475a5.999 5.999 0 010-8.483h0c2.327-2.327 6.127-2.325 8.467.016h0l1.242 1.242.177-.177-.177.177a1.083 1.083 0 001.532 0l1.242-1.242h0a6 6 0 018.482-.001 5.992 5.992 0 01.825 7.416l.212.133-.212-.133a1.083 1.083 0 00.34 1.494h0a1.083 1.083 0 001.494-.34c2.013-3.198 1.571-7.404-1.127-10.102l-.176.177.176-.177a8.167 8.167 0 00-11.546 0s0 0 0 0l-.476.476-.476-.475s0 0 0 0c-3.185-3.185-8.357-3.19-11.532-.016h0a8.165 8.165 0 000 11.547l11.242 11.241.177-.176-.177.176a1.083 1.083 0 001.532 0l-.177-.176.177.176 1.638-1.638a1.083 1.083 0 10-1.532-1.532z","fill":"#172542","stroke":"#172542","stroke-width":".5"}}),_c('circle',{attrs:{"cx":"35","cy":"28","r":"4","fill":"#172542"}})])
          )
        }
      }
    